import axios from "axios";
import { throwIfNullOrZeroOrNegative } from "../errors";

const endpoint = 'srsCodes';

export default {

    async getFromCurrentUser() {
        const uri = `${endpoint}/currentUser`;
        const response = await axios.get(uri);
        return response.data;
    },

    async getVipSalesAsync({ pageNumber, pageSize }) {
        throwIfNullOrZeroOrNegative(pageNumber, 'pageNumber')
        throwIfNullOrZeroOrNegative(pageSize, 'pageSize')
        const uri = `${endpoint}/vipSales`
        const response = await axios.get(uri, {
            params: {
                pageNumber: Number(pageNumber),
                pageSize: Number(pageSize),
            },
        })
        return response.data
    },

    async search({ searchValue, supplierInternalId, userId }) {
        const uri = `${endpoint}/search`;
        const response = await axios.post(uri, { searchValue, supplierInternalId, userId });
        return response.data;
    },


    async update({ newSrsCode /* string */, stockItemInternalId /* string */, itemNo /* string */ }) {
        throwIfNullOrZeroOrNegative(newSrsCode, 'newSrsCode')
        throwIfNullOrZeroOrNegative(stockItemInternalId, 'stockItemInternalId')
        throwIfNullOrZeroOrNegative(itemNo, 'ProductCode')
        const response = await axios.put(endpoint, { newSrsCode, stockItemInternalId, itemNo });
        return response.data;
    },
    async getCurrentSupplier({ id }) {
        throwIfNullOrZeroOrNegative(id, 'Id was null');
        const response = await axios.get(`${endpoint}/${id}`);
        return response.data;
    }
};
